import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

export const useVisualViewportSize = (debounceDelay = 500) => {
  const [visualViewportSize, setVisualViewportSize] = useState(getVisualViewportSize);

  useEffect(() => {
    const handleResize = debounce(() => {
      setVisualViewportSize(getVisualViewportSize());
    }, debounceDelay);

    window.visualViewport?.addEventListener('resize', handleResize);

    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize);
    };
  }, [debounceDelay]);

  return visualViewportSize;
};

function getVisualViewportSize() {
  return {
    height: window.visualViewport?.height ?? window.innerHeight,
    width: window.visualViewport?.width ?? window.innerWidth,
  };
}
